var VueScrollTo = require('vue-scrollto');

import 'core-js';

import Vue from 'vue';

Vue.config.devtools = process.env.NODE_ENV == 'development';
// Vue.config.devtools = true

import Search from './components/search.vue';

/**
 * For more information and options, please see
 * https://github.com/rigor789/vue-scrollto?ref=madewithvuejs.com
 *
 * We are using VUE directives on the button elements,
 * so that the scroll event happens on pagination,
 * which is why it is imported this way.
 */
Vue.use(VueScrollTo)

Vue.component('ankiro', Search);

// http://simple-vue-validator.maijin.info/
// import SimpleVueValidation from 'simple-vue-validator'

// SimpleVueValidation.extendTemplates({
//   error: 'Fejl.',
//   required: 'Påkrævet.',
//   float: 'Skal være et tal.',
//   integer: 'Skal være et tal.',
//   number: 'Skal være et tal.',
//   lessThan: 'Skal være mindre end {0}.',
//   lessThanOrEqualTo: 'Skal være mindre end eller lig med {0}.',
//   greaterThan: 'Skal være større end {0}.',
//   greaterThanOrEqualTo: 'Skal være større end eller lig med {0}.',
//   between: 'Skal være mellem {0} og {1}.',
//   length: 'Skal være {0} tal (Eks. 1970)',
//   minLength: 'Skal have mindste {0} karakterer.',
//   maxLength: 'Kan maks have {0} Karakterer.',
//   email: 'Ugyldig email.',
// })

// Vue.prototype.$Validator = SimpleVueValidation.Validator;

// Vue.use(SimpleVueValidation)

var rootID = 'ankiro-rest-search'

if(document.getElementById(rootID)){
  new Vue({
    el: '#' + rootID
  })
}
